import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { setGlobalVariable } from '../shared';

const News = ({ activeTab, baseUrl }) => {

    const [intValue, setIntValue] = useState(null);

    useEffect(() => {
      const studentkey = sessionStorage.getItem("studentkey");
      const districtID = sessionStorage.getItem("districtID");
      const token = sessionStorage.getItem("authToken");
      const headers = {
        'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        'Content-Type': 'application/json', // Optional: Define the content type if needed
      };
      if (token != null) {
      axios
        .get(baseUrl + `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`, { headers })
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log('Fetched intValue:', fetchedValue);
        })
        .catch((error) => {
          console.error('Error fetching intValue:', error);
        });
      }
    }, []);

    const fontsize = {
      fontSize: "16px", // Adjust font size as needed
      lineHeight: "1.5", // Optional: Improve readability with line height
    };

    // Dummy news data
    const currentNews = [
      { date: "September 01, 2022", from: "News Source 1", description: "Please review your assignments and turn in everything from the summer." },
      { date: "August 30, 2022", from: "News Source 2", description: "Welcome back to school." },
      { date: "July 15, 2022", from: "News Source 3", description: "Exciting event happening Followed by more information." },
    ];

    // Dummy pagination values
    const currentPageNews = 1;
    const totalPagesNews = 1;

    return (
      <div>
        {/* News Rows */}
        <div className="news-rows" style={fontsize}>
          {currentNews.map((newsItem, index) => (
            <div key={index}>
              <div className="news-row">
                <div className="news-details">
                  <div className="news-date">{newsItem.date}</div>
                  <div className="news-from">From: {newsItem.from}</div>
                  <div className="news-description">
                    {newsItem.description.split('\n').map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </div>
                </div>
              </div>
              {/* Add a line separator after each row except the last one */}
              {index < currentNews.length - 1 && <hr />}
            </div>
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => { }} disabled={currentPageNews === 1}>
            Previous
          </button>
          <span>
            Page {currentPageNews} of {totalPagesNews}
          </span>
          <button onClick={() => { }} disabled={currentPageNews === totalPagesNews}>
            Next
          </button>
        </div>
      </div>
    );
  };

  export default News;